/** * * Asynchronously loads the component for
DigitalSecurity
* */ import { lazyLoad } from "utils/loadable";
export const DigitalSecurity = lazyLoad(
  () => import("./index"),
  (module) => module.DigitalSecurity
);
